import { FileSourceEnum as e } from "./file-source-enum.mjs";
import { FileTypeEnum as t } from "./file-type-enum.mjs";
//#region src/files/data-file.ts
var n = (n) => {
	if (typeof n != "object" || !n) return !1;
	let r = n;
	return typeof r.id == "number" && typeof r.name == "string" && typeof r.filename == "string" && typeof r.path == "string" && (typeof r.thumbnail == "string" || r.thumbnail === null) && Object.values(e).includes(r.source) && typeof r.size == "number" && Object.values(t).includes(r.type) && typeof r.createdAt == "string";
};
//#endregion
export { n as isDataFileInterface };
